<div class="sk-page" *ngIf="!loading && auftrag">

  <!-- Hero-Kopf -->
  <div class="sk-hero">
    <button mat-icon-button class="sk-back" (click)="back()" aria-label="Zurück zum Stammkunden">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <div class="sk-hero-info">
      <h1>
        {{auftrag.title}}
        <span class="status-chip hero-chip" [attr.data-status]="auftrag.status">{{statusLabels[auftrag.status]}}</span>
      </h1>
      <div class="sk-hero-sub">
        <span><mat-icon class="sk-inline-icon">badge</mat-icon>{{auftrag.customerName}}</span>
        <span *ngIf="auftrag.orderNumber"><mat-icon class="sk-inline-icon">tag</mat-icon>{{auftrag.orderNumber}}</span>
        <span *ngIf="auftrag.location"><mat-icon class="sk-inline-icon">location_on</mat-icon>{{auftrag.location}}</span>
      </div>
    </div>
    <span class="sk-hero-spacer"></span>
    <div class="sk-hero-actions">
      <button mat-raised-button class="sk-btn-light" *ngIf="canManage" (click)="openEinsatzForm()">
        <mat-icon>add</mat-icon> Einsatz planen
      </button>
      <button mat-stroked-button class="sk-btn-ghost" (click)="openPlanung()">
        <mat-icon>calendar_view_week</mat-icon> Planungsboard
      </button>
      <button mat-icon-button class="sk-back" *ngIf="canManage" (click)="editAuftrag()" matTooltip="Auftrag bearbeiten">
        <mat-icon>edit</mat-icon>
      </button>
    </div>
  </div>

  <!-- Status-Workflow als Schritte -->
  <div class="sk-card stepper-card">
    <div class="stepper" [class.clickable]="canChangeStatus">
      <button class="step" *ngFor="let s of statusSteps; let i = index"
              [class.done]="i < currentStatusIndex"
              [class.current]="i === currentStatusIndex"
              [disabled]="!canSetStatus(s)"
              (click)="setStatus(s)"
              [matTooltip]="canSetStatus(s)
                ? 'Status setzen: ' + statusLabels[s]
                : statusLabels[s] + (canChangeStatus ? '' : ' (keine Berechtigung)')">
        <span class="step-dot">
          <mat-icon *ngIf="i < currentStatusIndex">check</mat-icon>
          <span *ngIf="i >= currentStatusIndex">{{i + 1}}</span>
        </span>
        <span class="step-label">{{statusLabels[s]}}</span>
      </button>
    </div>
    <p class="stepper-hint sk-muted" *ngIf="canChangeStatus">
      Tipp: Klicke auf einen Schritt, um den Status zu setzen.
    </p>
  </div>

  <!-- Auftragsdaten -->
  <div class="sk-card info-card" *ngIf="auftrag.description || auftrag.receivedDate || auftrag.startDate || auftrag.dueDate || auftrag.primaryWarehouseName">
    <div class="info-grid">
      <div class="info-item" *ngIf="auftrag.receivedDate">
        <label>Auftragseingang</label>
        <span>{{auftrag.receivedDate | date:'dd.MM.yyyy'}}</span>
      </div>
      <div class="info-item" *ngIf="auftrag.startDate">
        <label>Geplanter Beginn</label>
        <span>{{auftrag.startDate | date:'dd.MM.yyyy'}}</span>
      </div>
      <div class="info-item" *ngIf="auftrag.dueDate">
        <label>Fertigstellung bis</label>
        <span>{{auftrag.dueDate | date:'dd.MM.yyyy'}}</span>
      </div>
      <div class="info-item" *ngIf="auftrag.primaryWarehouseName">
        <label>Lager</label>
        <span>{{auftrag.primaryWarehouseName}}</span>
      </div>
    </div>
    <p class="description" *ngIf="auftrag.description">{{auftrag.description}}</p>
  </div>

  <!-- Einsätze nach Tagen -->
  <div class="sk-section-head">
    <h2><mat-icon>event_available</mat-icon> Einsatzplanung ({{assignments.length}})</h2>
    <span class="sk-spacer"></span>
    <button mat-raised-button color="primary" *ngIf="canManage" (click)="openEinsatzForm()">
      <mat-icon>add</mat-icon> Einsatz planen
    </button>
  </div>

  <div class="sk-empty" *ngIf="assignments.length === 0">
    <div class="sk-empty-icon"><mat-icon>event_busy</mat-icon></div>
    <p>Noch keine Einsätze geplant.<br>
      <span class="sk-muted">Plane, wer wann auf dieser Baustelle arbeitet – auf Wunsch mit Kalender-Einladung.</span>
    </p>
    <button mat-raised-button color="primary" *ngIf="canManage" (click)="openEinsatzForm()">
      <mat-icon>add</mat-icon> Ersten Einsatz planen
    </button>
  </div>

  <div class="day-group" *ngFor="let g of dayGroups; trackBy: trackByDay">
    <div class="day-head">
      <mat-icon>today</mat-icon>
      <strong>{{g.day | date:'EEEE, dd.MM.yyyy'}}</strong>
      <span class="sk-muted">{{g.items.length}} {{g.items.length === 1 ? 'Einsatz' : 'Einsätze'}}</span>
    </div>

    <div class="sk-card einsatz-card" [class.sk-card-hover]="canManage"
         *ngFor="let e of g.items; trackBy: trackByEinsatz" (click)="canManage && openEinsatzForm(e)">
      <div class="einsatz-row">
        <div class="einsatz-zeit">
          <strong>{{e.start | date:'HH:mm'}}</strong>
          <span class="sk-muted">– {{e.end | date:'HH:mm'}}</span>
        </div>
        <div class="einsatz-main">
          <div class="einsatz-title-row">
            <strong>{{e.assignedUserName || e.assignedUserId}}</strong>
            <span class="work-chip" [attr.data-status]="e.workStatus">{{workStatusLabel(e.workStatus)}}</span>
            <mat-icon *ngIf="e.inviteSent" class="invite-icon" matTooltip="Kalender-Einladung verschickt">mark_email_read</mat-icon>
          </div>
          <div class="einsatz-meta">
            <span *ngIf="e.title && auftrag && e.title !== auftrag.title">{{e.title}}</span>
            <span *ngIf="e.location"><mat-icon class="sk-inline-icon">location_on</mat-icon>{{e.location}}</span>
            <span *ngIf="e.participantNames.length > 0">
              <mat-icon class="sk-inline-icon">groups</mat-icon>{{e.participantNames.join(', ')}}
            </span>
            <span *ngIf="(e.workerNames ?? []).length > 0">
              <mat-icon class="sk-inline-icon">construction</mat-icon>{{e.workerNames.join(', ')}}
            </span>
            <span *ngIf="(e.materials ?? []).length > 0">
              <mat-icon class="sk-inline-icon">handyman</mat-icon>{{materialSummary(e)}}
            </span>
          </div>
        </div>
        <button mat-icon-button *ngIf="canManage" (click)="deleteAssignment(e, $event)" matTooltip="Einsatz löschen">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Material-Übersicht über alle Einsätze.
       Für Takeda bewusst ausgeblendet: dort erscheint dasselbe Material unten in
       der Takeda-Materialansicht, die Alt- und Takeda-Erfassung zu EINER Liste
       zusammenführt. Sonst stünde jede Altposition zweimal auf der Seite. -->
  <ng-container *ngIf="hasMaterials && !isTakedaAuftrag">
    <div class="sk-section-head material-head">
      <h2><mat-icon>handyman</mat-icon> Material</h2>
      <span class="material-badge" *ngIf="materialSubmittedCount > 0">{{ materialSubmittedCount }} zur Freigabe</span>
      <span class="sk-spacer"></span>
      <button mat-stroked-button color="primary" *ngIf="canManage && materialSubmittedCount > 0"
              (click)="approveAllMaterials()">
        <mat-icon>done_all</mat-icon> Alle freigeben
      </button>
      <div class="sk-filter-chips">
        <button class="sk-filter-chip" [class.active]="materialView === 'gesamt'"
                (click)="materialView = 'gesamt'">Gesamt</button>
        <button class="sk-filter-chip" [class.active]="materialView === 'einsatz'"
                (click)="materialView = 'einsatz'">Nach Einsatz</button>
      </div>
    </div>
    <p class="sk-muted material-hint" *ngIf="materialView === 'gesamt' && canManage && materialSubmittedCount > 0">
      Zum Freigeben einzelner Posten in die Ansicht „Nach Einsatz" wechseln.
    </p>

    <!-- Gesamtsummen (gleiches Material zusammengezählt) -->
    <div class="sk-card material-card" *ngIf="materialView === 'gesamt'">
      <div class="material-line" *ngFor="let m of materialTotals">
        <span class="mat-qty">{{m.quantity}} {{m.unit}}</span>
        <span class="mat-name">{{m.name}}</span>
      </div>
    </div>

    <!-- Aufgeschlüsselt nach Einsatz-Terminen -->
    <ng-container *ngIf="materialView === 'einsatz'">
      <div class="sk-card material-card" *ngFor="let g of materialDayGroups; trackBy: trackByDay">
        <div class="material-day-head">
          <mat-icon>today</mat-icon>
          <strong>{{g.day | date:'EEEE, dd.MM.yyyy'}}</strong>
        </div>
        <div class="material-einsatz" *ngFor="let e of g.items; trackBy: trackByEinsatz">
          <div class="material-einsatz-head">
            <mat-icon class="sk-inline-icon">person</mat-icon>
            {{e.start | date:'HH:mm'}} · {{e.assignedUserName || e.assignedUserId}}
            <span *ngIf="e.title && auftrag && e.title !== auftrag.title" class="sk-muted">· {{e.title}}</span>
          </div>
          <div class="material-line" *ngFor="let m of e.materials">
            <span class="mat-qty">{{m.quantity}} {{m.unit}}</span>
            <span class="mat-name">{{m.name}}</span>
            <span class="status-chip time-chip mat-status" [attr.data-status]="m.status || 'Submitted'">
              <mat-icon *ngIf="m.status === 'Locked'" class="sk-inline-icon">lock</mat-icon>
              {{ materialStatusLabel(m.status) }}
            </span>
            <div class="mat-actions" *ngIf="canManage">
              <button mat-icon-button *ngIf="(m.status || 'Submitted') === 'Submitted'"
                      (click)="approveMaterialLine(m, $event)" matTooltip="Material freigeben">
                <mat-icon>check_circle</mat-icon>
              </button>
              <button mat-icon-button *ngIf="m.status === 'Approved'"
                      (click)="reopenMaterialLine(m, $event)" matTooltip="Freigabe zurücknehmen">
                <mat-icon>lock_open</mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-container>

  <!-- ===================================================== -->
  <!-- TAKEDA-MATERIAL aus den Tagesberichten.               -->
  <!-- Nur für Takeda; andere Kunden behalten oben die       -->
  <!-- unveränderte Material-Ansicht. Bewusst ohne Preise.   -->
  <!-- ===================================================== -->
  <ng-container *ngIf="isTakedaAuftrag && hasTakedaMaterial && takedaProjekt as tp">
    <div class="sk-section-head material-head">
      <h2><mat-icon>handyman</mat-icon> Materialien</h2>
      <span class="hours-total" *ngIf="zeigeMaterialPreise && takedaPricing?.materialSumme != null">
        {{ takedaPricing?.materialSumme | number:'1.2-2' }} €
      </span>
      <span class="sk-spacer"></span>

      <!-- Bearbeiten ist ein bewusster Schalter: beide Ansichten bleiben sonst
           reine Übersicht, damit beim Durchsehen nichts verstellt wird. -->
      <button mat-stroked-button *ngIf="canEditTakedaMaterial"
              [color]="materialEditMode ? 'primary' : undefined"
              (click)="toggleMaterialEdit()">
        <mat-icon>{{ materialEditMode ? 'check' : 'edit' }}</mat-icon>
        {{ materialEditMode ? 'Fertig' : 'Bearbeiten' }}
      </button>

      <div class="sk-filter-chips">
        <button class="sk-filter-chip" [class.active]="materialView === 'gesamt'"
                (click)="materialView = 'gesamt'">Gesamt</button>
        <button class="sk-filter-chip" [class.active]="materialView === 'einsatz'"
                (click)="materialView = 'einsatz'">Nach Einsatz</button>
      </div>
    </div>

    <!-- Preisfreie Ansicht: vor Abgeschlossen oder ohne Preisberechtigung -->
    <ng-container *ngIf="materialView === 'gesamt' && !zeigeMaterialPreise">

      <div class="sk-card material-card" *ngIf="tp.lvMaterialGesamt.length > 0">
        <div class="material-day-head">
          <mat-icon>format_list_numbered</mat-icon>
          <strong>Leistungsverzeichnis</strong>
        </div>
        <div class="material-line takeda-mat-line"
             *ngFor="let m of tp.lvMaterialGesamt; trackBy: trackByTakedaLvMaterial">

          <!-- Korrigierbar, sobald die Zeile aus genau einer Erfassung stammt. -->
          <span class="mat-qty takeda-korr-menge" *ngIf="materialBearbeitung && m.id > 0">
            <input type="number" min="0.0001" step="0.01" class="takeda-korr-input"
                   [value]="m.menge" (blur)="setLvMaterialMenge(m, $any($event.target).value)">
            {{ m.einheit }}
          </span>
          <span class="mat-qty" *ngIf="!materialBearbeitung || m.id === 0">
            {{ m.menge | number:'1.0-4' }} {{ m.einheit }}
          </span>

          <span class="mat-name">
            <strong class="takeda-mat-nr">{{ m.nummer }}</strong>
            {{ takedaLvText(m) }}
            <span class="sk-muted takeda-mat-zusatz" *ngIf="takedaLvZusatz(m) as zusatz">· {{ zusatz }}</span>
            <span class="sk-muted takeda-mat-zusatz"
                  *ngIf="materialBearbeitung && m.quellenAnzahl > 1">
              · aus {{ m.quellenAnzahl }} Erfassungen – zum Ändern „Nach Einsatz"
            </span>
          </span>

          <button mat-icon-button color="warn" *ngIf="materialBearbeitung && m.id > 0"
                  (click)="removeLvMaterial(m)" matTooltip="LV-Position entfernen">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>

      <!-- Freies Material bleibt Zeile für Zeile: gleiche Texte werden NICHT
           automatisch zusammengerechnet. -->
      <div class="sk-card material-card" *ngIf="tp.freiesMaterialGesamt.length > 0">
        <div class="material-day-head">
          <mat-icon>inventory_2</mat-icon>
          <strong>Freies Material</strong>
        </div>
        <div class="material-line takeda-mat-line"
             *ngFor="let m of tp.freiesMaterialGesamt; trackBy: trackByTakedaFreiesMaterial">

          <!-- Freies Material wird nie zusammengefasst, jede Zeile ist eindeutig. -->
          <ng-container *ngIf="!materialBearbeitung">
            <span class="mat-qty">{{ m.menge | number:'1.0-4' }} {{ m.einheit }}</span>
            <span class="mat-name">{{ m.bezeichnung }}</span>
          </ng-container>

          <ng-container *ngIf="materialBearbeitung">
            <span class="mat-qty takeda-korr-menge">
              <input type="number" min="0.0001" step="0.01" class="takeda-korr-input"
                     [value]="m.menge"
                     (blur)="setFreiesMaterialFeld(m, 'menge', $any($event.target).value)">
              <input type="text" class="takeda-korr-input takeda-korr-einheit"
                     [value]="m.einheit || ''" placeholder="Einheit"
                     (blur)="setFreiesMaterialFeld(m, 'einheit', $any($event.target).value)">
            </span>
            <span class="mat-name">
              <input type="text" class="takeda-korr-input takeda-korr-bezeichnung"
                     [value]="m.bezeichnung"
                     (blur)="setFreiesMaterialFeld(m, 'bezeichnung', $any($event.target).value)">
            </span>
          </ng-container>

          <span class="mat-name takeda-mat-herkunft">
            <span class="sk-muted takeda-mat-zusatz" *ngIf="m.referenzNummer">
              {{ takedaReferenzLabel(m.referenzTyp) }} {{ m.referenzNummer }}
            </span>
            <span class="sk-muted takeda-mat-zusatz" *ngIf="m.workDate">
              · {{ m.workDate | date:'dd.MM.yyyy' }}
            </span>
            <!-- Herkunft nur als Hinweis: die Zeile ist ganz normal korrigierbar. -->
            <span class="sk-muted takeda-mat-zusatz" *ngIf="istLegacy(m)"
                  matTooltip="Aus der ursprünglichen Erfassung. Die Originalzeile bleibt als Nachweis erhalten.">
              · Alterfassung
            </span>
          </span>

          <button mat-icon-button color="warn" *ngIf="materialBearbeitung && !istLegacy(m)"
                  (click)="removeFreiesMaterial(m)" matTooltip="Material entfernen">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
    </ng-container>

    <!-- ── Bepreist: Gesamt (ab Abgeschlossen, nur Bauleiter/Admin) ── -->
    <ng-container *ngIf="materialView === 'gesamt' && zeigeMaterialPreise && takedaPricing as tpr">
      <div class="sk-card material-card">
        <div class="material-line takeda-preis-line takeda-preis-head">
          <span class="mat-name">Position</span>
          <span class="takeda-preis-menge">Menge</span>
          <span class="takeda-preis-satz">Preis/Einheit</span>
          <span class="takeda-preis-summe">Gesamt</span>
        </div>

        <div class="material-line takeda-preis-line" *ngFor="let z of tpr.materialGesamt">
          <span class="mat-name">
            <strong class="takeda-mat-nr" *ngIf="z.nummer">{{ z.nummer }}</strong>
            {{ z.bezeichnung || z.stichwort }}
            <span class="sk-muted takeda-mat-zusatz" *ngIf="z.art === 'Frei'">· frei erfasst</span>
            <span class="sk-muted takeda-mat-zusatz" *ngIf="z.art === 'Legacy'">· Alterfassung</span>
          </span>

          <span class="takeda-preis-menge">{{ z.menge | number:'1.0-4' }} {{ z.einheit }}</span>

          <!-- Freies Material: manuell bepreisbar, solange nicht abgerechnet -->
          <span class="takeda-preis-satz">
            <ng-container *ngIf="istBepreisbareZeile(z); else satzReadonly">
              <input type="number" min="0" step="0.01" class="takeda-preis-input"
                     [(ngModel)]="z.preisProEinheit"
                     [disabled]="istSpeichernd(z)"
                     (blur)="saveFreiesMaterialPreis(z)"
                     placeholder="€/Einheit">
            </ng-container>
            <ng-template #satzReadonly>
              <ng-container *ngIf="z.preisProEinheit != null; else keinPreis">
                {{ z.preisProEinheit | number:'1.2-2' }} €
              </ng-container>
              <ng-template #keinPreis>
                <span class="takeda-preis-fehlt">kein Preis</span>
              </ng-template>
            </ng-template>
          </span>

          <span class="takeda-preis-summe">
            <ng-container *ngIf="z.gesamt != null">{{ z.gesamt | number:'1.2-2' }} €</ng-container>
          </span>
        </div>

        <div class="material-line takeda-preis-line takeda-preis-summenzeile"
             *ngIf="tpr.materialSumme != null">
          <span class="mat-name"><strong>Material gesamt</strong></span>
          <span class="takeda-preis-menge"></span>
          <span class="takeda-preis-satz"></span>
          <span class="takeda-preis-summe">
            <strong *ngIf="!materialPreiseFehlen">{{ tpr.materialSumme | number:'1.2-2' }} €</strong>
            <!-- Keine Zahl zeigen, die wie eine fertige Summe aussieht. -->
            <span class="takeda-preis-fehlt" *ngIf="materialPreiseFehlen">unvollständig</span>
          </span>
        </div>

        <!-- Erklärt, warum „Bepreist" noch nicht möglich ist. -->
        <p class="sk-muted material-hint" *ngIf="materialPreiseFehlen">
          {{ tpr.materialOhnePreis }}
          {{ tpr.materialOhnePreis === 1 ? 'Position hat' : 'Positionen haben' }}
          noch keinen Preis. Solange das so ist, lässt sich der Auftrag nicht auf
          „Bepreist" setzen. Positionen mit dem Hinweis „Alterfassung" stammen aus
          der ursprünglichen Erfassung – sie werden beim Bepreisen übernommen, die
          Originalzeile bleibt erhalten.
        </p>
      </div>
    </ng-container>

    <!-- ── Bepreist: Nach Einsatz ── -->
    <ng-container *ngIf="materialView === 'einsatz' && zeigeMaterialPreise && !materialBearbeitung && takedaPricing as tpr">
      <div class="sk-card material-card" *ngFor="let e of tpr.materialNachEinsatz">
        <div class="material-day-head">
          <mat-icon>today</mat-icon>
          <strong>{{ e.workDate | date:'EEEE, dd.MM.yyyy' }}</strong>
          <span class="sk-muted" *ngIf="e.assignmentTitle">· {{ e.assignmentTitle }}</span>
        </div>

        <div class="material-einsatz" *ngFor="let b of e.arbeitsbereiche">
          <div class="material-einsatz-head">
            <mat-icon class="sk-inline-icon">tag</mat-icon>
            {{ takedaReferenzLabel(b.referenzTyp) }} {{ b.referenzNummer || '–' }}
            <span class="sk-muted" *ngIf="b.ort">· {{ b.ort }}</span>
          </div>

          <div class="material-line takeda-preis-line" *ngFor="let z of b.zeilen">
            <span class="mat-name">
              <strong class="takeda-mat-nr" *ngIf="z.nummer">{{ z.nummer }}</strong>
              {{ z.bezeichnung || z.stichwort }}
              <span class="sk-muted takeda-mat-zusatz" *ngIf="z.art === 'Frei'">· frei erfasst</span>
            <span class="sk-muted takeda-mat-zusatz" *ngIf="z.art === 'Legacy'">· Alterfassung</span>
            </span>
            <span class="takeda-preis-menge">{{ z.menge | number:'1.0-4' }} {{ z.einheit }}</span>
            <span class="takeda-preis-satz">
              <ng-container *ngIf="z.preisProEinheit != null; else keinPreisEinsatz">
                {{ z.preisProEinheit | number:'1.2-2' }} €
              </ng-container>
              <ng-template #keinPreisEinsatz>
                <span class="takeda-preis-fehlt">kein Preis</span>
              </ng-template>
            </span>
            <span class="takeda-preis-summe">
              <ng-container *ngIf="z.gesamt != null">{{ z.gesamt | number:'1.2-2' }} €</ng-container>
            </span>
          </div>
        </div>
      </div>
      <p class="sk-muted material-hint" *ngIf="freiesMaterialBearbeitbar">
        Freies Material wird in der Ansicht „Gesamt" bepreist.
      </p>
    </ng-container>

    <!-- Hinweis: korrigiert wird nur in der Einsatzansicht, dort ist der
         Arbeitsbereich eindeutig (wie bei den Stunden). -->
    <p class="sk-muted material-hint" *ngIf="materialKorrekturHinweis">
      Mengen und freies Material lassen sich hier direkt ändern.
      Zum <strong>Hinzufügen</strong> in die Ansicht „Nach Einsatz" wechseln –
      dort ist der Einsatz eindeutig, zu dem das Material gehört.
    </p>

    <!-- Preisfreie Ansicht: Nach Einsatz -->
    <ng-container *ngIf="materialView === 'einsatz' && (!zeigeMaterialPreise || materialBearbeitung)">
      <!-- Leere Arbeitsbereiche erscheinen nur, solange korrigiert werden darf –
           dort trägt der Bauleiter vergessenes Material nach. -->
      <div class="sk-card material-card" *ngFor="let e of tp.materialNachEinsatz">
        <ng-container *ngIf="zeigeEinsatzMaterial(e)">
        <div class="material-day-head">
          <mat-icon>today</mat-icon>
          <strong>{{ e.workDate | date:'EEEE, dd.MM.yyyy' }}</strong>
          <span class="sk-muted" *ngIf="e.assignmentTitle">· {{ e.assignmentTitle }}</span>
        </div>

        <div class="material-einsatz" *ngFor="let b of e.arbeitsbereiche"
             [hidden]="!zeigeArbeitsbereich(b)">
          <div class="material-einsatz-head">
            <mat-icon class="sk-inline-icon">tag</mat-icon>
            {{ takedaReferenzLabel(b.referenzTyp) }} {{ b.referenzNummer || '–' }}
            <span class="sk-muted" *ngIf="b.ort">· {{ b.ort }}</span>
          </div>

          <!-- LV-Positionen -->
          <div class="material-line takeda-mat-line" *ngFor="let m of b.lvPositionen">
            <span class="mat-qty" *ngIf="!materialBearbeitung">
              {{ m.menge | number:'1.0-4' }} {{ m.einheit }}
            </span>
            <span class="mat-qty takeda-korr-menge" *ngIf="materialBearbeitung">
              <input type="number" min="0.0001" step="0.01" class="takeda-korr-input"
                     [value]="m.menge" (blur)="setLvMaterialMenge(m, $any($event.target).value)">
              {{ m.einheit }}
            </span>
            <span class="mat-name">
              <strong class="takeda-mat-nr">{{ m.nummer }}</strong>
              {{ takedaLvText(m) }}
            </span>
            <button mat-icon-button color="warn" *ngIf="materialBearbeitung"
                    (click)="removeLvMaterial(m)" matTooltip="LV-Position entfernen">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>

          <!-- Freies Material -->
          <div class="material-line takeda-mat-line" *ngFor="let m of b.freieMaterialien">
            <ng-container *ngIf="!materialBearbeitung">
              <span class="mat-qty">{{ m.menge | number:'1.0-4' }} {{ m.einheit }}</span>
              <span class="mat-name">
                {{ m.bezeichnung }}
                <span class="sk-muted takeda-mat-zusatz">
                  · {{ istLegacy(m) ? 'Alterfassung' : 'frei erfasst' }}
                </span>
              </span>
            </ng-container>

            <ng-container *ngIf="materialBearbeitung">
              <span class="mat-qty takeda-korr-menge">
                <input type="number" min="0.0001" step="0.01" class="takeda-korr-input"
                       [value]="m.menge"
                       (blur)="setFreiesMaterialFeld(m, 'menge', $any($event.target).value)">
                <input type="text" class="takeda-korr-input takeda-korr-einheit"
                       [value]="m.einheit || ''" placeholder="Einheit"
                       (blur)="setFreiesMaterialFeld(m, 'einheit', $any($event.target).value)">
              </span>
              <span class="mat-name">
                <input type="text" class="takeda-korr-input takeda-korr-bezeichnung"
                       [value]="m.bezeichnung"
                       (blur)="setFreiesMaterialFeld(m, 'bezeichnung', $any($event.target).value)">
                <span class="sk-muted takeda-mat-zusatz">
                  · {{ istLegacy(m) ? 'Alterfassung' : 'frei erfasst' }}
                </span>
              </span>
              <button mat-icon-button color="warn" *ngIf="!istLegacy(m)"
                      (click)="removeFreiesMaterial(m)"
                      matTooltip="Material entfernen">
                <mat-icon>delete_outline</mat-icon>
              </button>
            </ng-container>
          </div>

          <!-- Korrektur-Aktionen je Arbeitsbereich -->
          <div class="takeda-korr-actions" *ngIf="materialBearbeitung">
            <button mat-stroked-button type="button" (click)="toggleLvAdd(b.arbeitsbereichId, b.assignmentId)">
              <mat-icon>add</mat-icon> LV-Position
            </button>
            <button mat-stroked-button type="button" (click)="addFreiesMaterial(b.arbeitsbereichId, b.assignmentId)">
              <mat-icon>add</mat-icon> Freies Material
            </button>
          </div>

          <!-- LV-Suche für genau diesen Arbeitsbereich -->
          <div class="takeda-korr-suche" *ngIf="materialBearbeitung && lvAddOffen(b.arbeitsbereichId, b.assignmentId)">
            <mat-form-field appearance="outline" class="takeda-korr-suchfeld">
              <mat-label>LV durchsuchen</mat-label>
              <input matInput [ngModel]="lvAddSearch" (ngModelChange)="onLvAddSearch($event)"
                     placeholder="Nummer, Bezeichnung oder Stichwort" autocomplete="off">
              <mat-icon matPrefix>search</mat-icon>
              <mat-spinner matSuffix *ngIf="lvAddLoading" diameter="18"></mat-spinner>
            </mat-form-field>

            <div class="takeda-korr-treffer" *ngFor="let p of lvAddResults">
              <span class="mat-name">
                <strong class="takeda-mat-nr">{{ p.nummer }}</strong>
                {{ p.bezeichnung || p.stichwort }}
                <span class="sk-muted takeda-mat-zusatz" *ngIf="p.einheit">· {{ p.einheit }}</span>
              </span>
              <button mat-stroked-button type="button" (click)="addLvMaterial(p)">
                <mat-icon>add</mat-icon> Hinzufügen
              </button>
            </div>

            <p class="sk-muted takeda-mat-zusatz"
               *ngIf="!lvAddLoading && lvAddSearch.length >= 2 && lvAddResults.length === 0">
              Keine passenden LV-Positionen gefunden.
            </p>
          </div>
        </div>
        </ng-container>
      </div>
    </ng-container>
  </ng-container>

  <!-- Stunden-Übersicht (ohne Preise) -->
  <div class="sk-section-head hours-head">
    <h2><mat-icon>schedule</mat-icon> Stunden</h2>
    <span class="hours-total" *ngIf="hasTimeEntries">{{ totalHours }} h gesamt</span>
    <span class="sk-spacer"></span>
    <!-- Umschaltung nur für Takeda; sonst bleibt die Tagesansicht wie bisher. -->
    <div class="sk-filter-chips" *ngIf="isTakedaAuftrag && hasTimeEntries">
      <button class="sk-filter-chip" [class.active]="hoursView === 'gesamt'"
              (click)="hoursView = 'gesamt'">Gesamt</button>
      <button class="sk-filter-chip" [class.active]="hoursView === 'einsatz'"
              (click)="hoursView = 'einsatz'">Nach Einsatz</button>
    </div>
    <button mat-stroked-button color="primary" *ngIf="canManage && submittedCount > 0" (click)="approveAll()">
      <mat-icon>done_all</mat-icon> Alle freigeben ({{ submittedCount }})
    </button>
    <button mat-raised-button color="primary" *ngIf="canManage" (click)="openZeitForm()">
      <mat-icon>add</mat-icon> Stunden erfassen
    </button>
  </div>

  <div class="sk-empty" *ngIf="!hasTimeEntries">
    <div class="sk-empty-icon"><mat-icon>schedule</mat-icon></div>
    <p>Noch keine Stunden erfasst.<br>
      <span class="sk-muted">Der Vorarbeiter meldet die geleisteten Stunden pro Person – hier gibst du sie frei.</span>
    </p>
    <button mat-raised-button color="primary" *ngIf="canManage" (click)="openZeitForm()">
      <mat-icon>add</mat-icon> Stunden erfassen
    </button>
  </div>

  <!-- Takeda, "Gesamt", bepreist (ab Bepreist, nur Bauleiter/Admin).
       Beträge stammen aus den eingefrorenen Schnappschüssen. -->
  <!-- Altauftrag ohne eingefrorene Sätze: ehrlich benennen statt 0,00 € zeigen. -->
  <div class="sk-card takeda-snapshot-hinweis" *ngIf="stundensaetzeFehlen">
    <mat-icon>warning_amber</mat-icon>
    <div class="takeda-snapshot-text">
      <strong>Stundensätze nicht eingefroren</strong>
      <span class="sk-muted">
        Dieser Auftrag wurde bepreist, bevor die Stundensätze historisch gesichert wurden.
        Deshalb fehlen {{ takedaPricing?.stundenOhneSnapshot }} Stundenbeträge.
        Nachtragen übernimmt die heute zugeordneten Sätze – bereits gesicherte Werte
        bleiben unverändert.
      </span>
    </div>
    <span class="sk-spacer"></span>
    <button mat-raised-button color="primary" *ngIf="canManage"
            (click)="nachtragenStundensaetze()" [disabled]="nachtragenLaeuft">
      <mat-spinner *ngIf="nachtragenLaeuft" diameter="18"></mat-spinner>
      <mat-icon *ngIf="!nachtragenLaeuft">history</mat-icon>
      Stundensätze nachtragen
    </button>
  </div>

  <ng-container *ngIf="isTakedaAuftrag && hoursView === 'gesamt'
                       && zeigeStundenPreise && takedaPricing as tpr">
    <div class="sk-card hours-card">
      <div class="hours-line takeda-preis-line takeda-preis-head">
        <span class="mat-name">Person</span>
        <span class="takeda-preis-menge">Stunden</span>
        <span class="takeda-preis-satz">€/h</span>
        <span class="takeda-preis-summe">Gesamt</span>
      </div>

      <div class="hours-line takeda-preis-line" *ngFor="let z of tpr.stundenGesamt">
        <span class="mat-name">
          <strong>{{ z.personName }}</strong>
          <span class="sk-muted takeda-mat-zusatz" *ngIf="z.rateLabel">· {{ z.rateLabel }}</span>
        </span>
        <span class="takeda-preis-menge">{{ z.hours }} h</span>
        <span class="takeda-preis-satz">
          <ng-container *ngIf="z.hourlyRate != null">{{ z.hourlyRate | number:'1.2-2' }} €</ng-container>
        </span>
        <span class="takeda-preis-summe">
          <ng-container *ngIf="z.gesamt != null">{{ z.gesamt | number:'1.2-2' }} €</ng-container>
        </span>
      </div>

      <div class="hours-line takeda-preis-line takeda-preis-summenzeile"
           *ngIf="tpr.stundenSumme != null">
        <span class="mat-name"><strong>Stunden gesamt</strong></span>
        <span class="takeda-preis-menge"></span>
        <span class="takeda-preis-satz"></span>
        <span class="takeda-preis-summe">
          <strong *ngIf="!stundensaetzeFehlen">{{ tpr.stundenSumme | number:'1.2-2' }} €</strong>
          <!-- Ohne Schnappschüsse wäre die Summe unvollständig – dann kein Betrag. -->
          <span class="takeda-preis-fehlt" *ngIf="stundensaetzeFehlen">unvollständig</span>
        </span>
      </div>
    </div>

    <div class="sk-card hours-card takeda-gesamtsumme" *ngIf="tpr.gesamtSumme != null">
      <div class="hours-line takeda-preis-line">
        <span class="mat-name"><strong>Auftragssumme (Material + Stunden)</strong></span>
        <span class="takeda-preis-summe">
          <strong *ngIf="!stundensaetzeFehlen">{{ tpr.gesamtSumme | number:'1.2-2' }} €</strong>
          <span class="takeda-preis-fehlt" *ngIf="stundensaetzeFehlen">
            unvollständig – Stundensätze fehlen
          </span>
        </span>
      </div>
    </div>
  </ng-container>

  <!-- Takeda, "Gesamt", preisfrei: vor Bepreist oder ohne Preisberechtigung. -->
  <ng-container *ngIf="isTakedaAuftrag && hoursView === 'gesamt'
                       && !zeigeStundenPreise && takedaProjekt as tp">
    <p class="sk-muted material-hint" *ngIf="canManage && submittedCount > 0">
      Zum Freigeben einzelner Einträge in die Ansicht „Nach Einsatz" wechseln.
    </p>
    <div class="sk-card hours-card" *ngIf="tp.stundenGesamt.length > 0">
      <div class="hours-line" *ngFor="let p of tp.stundenGesamt">
        <div class="hours-person">
          <strong>{{ p.personName }}</strong>
        </div>
        <span class="hours-value">{{ p.hours }} h</span>
      </div>
    </div>
  </ng-container>

  <!-- Takeda, "Nach Einsatz", bepreist -->
  <ng-container *ngIf="isTakedaAuftrag && hoursView === 'einsatz'
                       && zeigeStundenPreise && takedaPricing as tpr">
    <div class="sk-card hours-card" *ngFor="let e of tpr.stundenNachEinsatz">
      <div class="hours-day-head">
        <mat-icon>event_available</mat-icon>
        <strong>{{ e.workDate | date:'EEEE, dd.MM.yyyy' }}</strong>
        <span class="sk-muted" *ngIf="e.assignmentTitle">· {{ e.assignmentTitle }}</span>
        <span class="sk-spacer"></span>
        <span class="hours-day-sum">
          {{ e.hours }} h
          <ng-container *ngIf="e.gesamt != null"> · {{ e.gesamt | number:'1.2-2' }} €</ng-container>
        </span>
      </div>
      <div class="hours-line takeda-preis-line" *ngFor="let z of e.personen">
        <span class="mat-name">
          <strong>{{ z.personName }}</strong>
          <span class="sk-muted takeda-mat-zusatz" *ngIf="z.rateLabel">· {{ z.rateLabel }}</span>
        </span>
        <span class="takeda-preis-menge">{{ z.hours }} h</span>
        <span class="takeda-preis-satz">
          <ng-container *ngIf="z.hourlyRate != null">{{ z.hourlyRate | number:'1.2-2' }} €</ng-container>
        </span>
        <span class="takeda-preis-summe">
          <ng-container *ngIf="z.gesamt != null">{{ z.gesamt | number:'1.2-2' }} €</ng-container>
        </span>
      </div>
    </div>
  </ng-container>

  <!-- Takeda, Ansicht "Nach Einsatz": je Einsatz und Tag, Zeilen bleiben die
       einzelnen Einträge samt Status und Aktionen. -->
  <!-- Takeda, "Nach Einsatz", preisfrei: die bearbeitbare Detailliste mit
       Status-Chips und Freigabe. Ab "Bepreist" ersetzt sie die Ansicht oben,
       weil die Stunden dann eingefroren sind. -->
  <div class="sk-card hours-card"
       *ngFor="let g of (isTakedaAuftrag && hoursView === 'einsatz' && !zeigeStundenPreise
                          ? timeEinsatzGroups : []);
               trackBy: trackByTimeEinsatzGroup">
    <div class="hours-day-head">
      <mat-icon>event_available</mat-icon>
      <strong>{{ g.day | date:'EEEE, dd.MM.yyyy' }}</strong>
      <span class="sk-muted" *ngIf="g.title">· {{ g.title }}</span>
      <span class="sk-muted" *ngIf="g.assignmentId == null">· ohne Einsatz</span>
      <span class="sk-spacer"></span>
      <span class="hours-day-sum">{{ g.hours }} h</span>
    </div>
    <div class="hours-line" *ngFor="let t of g.items; trackBy: trackByEntry">
      <div class="hours-person">
        <strong>{{ t.personName }}</strong>
        <span class="hours-note sk-muted" *ngIf="t.note">{{ t.note }}</span>
      </div>
      <span class="hours-value">{{ t.hours }} h</span>
      <span class="status-chip time-chip" [attr.data-status]="t.status">
        <mat-icon *ngIf="t.status === 'Locked'" class="sk-inline-icon">lock</mat-icon>
        {{ timeStatusLabel(t.status) }}
      </span>
      <div class="hours-actions" *ngIf="canManage">
        <button mat-icon-button *ngIf="t.status === 'Submitted'" (click)="approveEntry(t, $event)"
                matTooltip="Freigeben">
          <mat-icon>check_circle</mat-icon>
        </button>
        <button mat-icon-button *ngIf="t.status === 'Approved'" (click)="reopenEntry(t, $event)"
                matTooltip="Freigabe zurücknehmen">
          <mat-icon>lock_open</mat-icon>
        </button>
        <button mat-icon-button *ngIf="t.status !== 'Locked'" (click)="openZeitForm(t)"
                matTooltip="Bearbeiten">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button *ngIf="t.status !== 'Locked'" (click)="deleteEntry(t, $event)"
                matTooltip="Löschen">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Nicht-Takeda: unveränderte Tagesansicht. -->
  <div class="sk-card hours-card"
       *ngFor="let g of (isTakedaAuftrag ? [] : timeDayGroups); trackBy: trackByDay">
    <div class="hours-day-head">
      <mat-icon>today</mat-icon>
      <strong>{{ g.day | date:'EEEE, dd.MM.yyyy' }}</strong>
      <span class="sk-spacer"></span>
      <span class="hours-day-sum">{{ g.hours }} h</span>
    </div>
    <div class="hours-line" *ngFor="let t of g.items; trackBy: trackByEntry">
      <div class="hours-person">
        <strong>{{ t.personName }}</strong>
        <span class="hours-note sk-muted" *ngIf="t.note">{{ t.note }}</span>
      </div>
      <span class="hours-value">{{ t.hours }} h</span>
      <span class="status-chip time-chip" [attr.data-status]="t.status">
        <mat-icon *ngIf="t.status === 'Locked'" class="sk-inline-icon">lock</mat-icon>
        {{ timeStatusLabel(t.status) }}
      </span>
      <div class="hours-actions" *ngIf="canManage">
        <button mat-icon-button *ngIf="t.status === 'Submitted'" (click)="approveEntry(t, $event)"
                matTooltip="Freigeben">
          <mat-icon>check_circle</mat-icon>
        </button>
        <button mat-icon-button *ngIf="t.status === 'Approved'" (click)="reopenEntry(t, $event)"
                matTooltip="Freigabe zurücknehmen">
          <mat-icon>lock_open</mat-icon>
        </button>
        <button mat-icon-button *ngIf="t.status !== 'Locked'" (click)="openZeitForm(t)"
                matTooltip="Bearbeiten">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button *ngIf="t.status !== 'Locked'" (click)="deleteEntry(t, $event)"
                matTooltip="Löschen">
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- ===================================================== -->
  <!-- ABRECHNUNGSEXPORT                                     -->
  <!-- Steht bewusst am Ende unter der Auftragssumme und     -->
  <!-- erscheint erst, wenn der Auftrag abgerechnet ist.     -->
  <!-- ===================================================== -->
  <div class="sk-card takeda-export-card" *ngIf="canExportTakeda">
    <div class="takeda-export-text">
      <strong><mat-icon class="sk-inline-icon">description</mat-icon> Regie-Abrechnung exportieren</strong>
      
    </div>
    
    
    <button mat-stroked-button color="primary" (click)="exportPdf()"
            [disabled]="exportLaeuft !== null || excelDialogOffen">
      <mat-spinner *ngIf="exportLaeuft === 'pdf'" diameter="18"></mat-spinner>
      <mat-icon *ngIf="exportLaeuft !== 'pdf'">picture_as_pdf</mat-icon>
      PDF exportieren
    </button>
    <button mat-stroked-button color="primary" (click)="exportExcel()"
            [disabled]="exportLaeuft !== null || excelDialogOffen">
      <mat-spinner *ngIf="exportLaeuft === 'excel'" diameter="18"></mat-spinner>
      <mat-icon *ngIf="exportLaeuft !== 'excel'">table_view</mat-icon>
      Excel exportieren
    </button>
  </div>
</div>

<div class="sk-loading" *ngIf="loading">
  <mat-spinner diameter="42"></mat-spinner>
</div>
